<template>
  <p-child
    :tag="tag"
    :class="classList"
    :namespace="namespace"
    :register-only-with-root-parent="registerOnlyWithRootParent"
    :register-with-all-parents="registerWithAllParents"
    v-on="{register: onRegister, unregister: onUnregister, ...$listeners}"
  >
    <slot
      :class="classList"
      :active="isActive"
      :toggle="toggleItem"
    ></slot>
  </p-child>
</template>

<script lang="ts">
  import mixins from '../../mixins';

  export default mixins().extend({
    props: {
      value: { type: undefined, default: undefined },
      tag: { type: String, default: 'div' },
      disabled: { type: Boolean, default: false },
      /** Registers **only** with the topmost parent, default behaviour is to register with closest only */
      registerOnlyWithRootParent: { type: Boolean, default: false },
      /** Registers with all parents above this child, default behaviour is to register with closest only */
      registerWithAllParents: { type: Boolean, default: false },
      namespace: { type: String, default: 'p-selection-group' },
    },
    inject: {
      register: { default: () => {} },
      unregister: { default: () => {} },
    },
    watch: {
      isActive() {
        this.$emit('active', this.isActive);
      },
    },
    data: () => ({
      isActive: false,
      activeClass: 'active',
    }),
    computed: {
      classList(): {} {
        return {
          'p-selection-child': true,
          disabled: this.disabled,
          [this.activeClass as string]: this.activeClass !== undefined && this.isActive && !this.disabled,
        };
      },
    },
    methods: {
      // eslint-disable-next-line no-unused-vars
      onRegister(register: (item: any)=>{}) {
        register(this);
      },
      // eslint-disable-next-line no-unused-vars
      onUnregister(unregister: (item: any)=>{}) {
        unregister(this);
      },
      toggleItem() {
        if (!this.disabled) {
          this.$emit('change', this);
          this.$emit('input', this);
        }
      },
    },
  });
</script>
